import { render, staticRenderFns } from "./AddEntities.vue?vue&type=template&id=1b643626&scoped=true"
import script from "./AddEntities.vue?vue&type=script&lang=js"
export * from "./AddEntities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b643626",
  null
  
)

export default component.exports